































































// Utilities
import { PropType } from 'vue';
import mixins from '@/utils/mixins';

// models
import { Configuration } from '@/models/configurator/configuration';
import { Module } from '@/models/configurator/module';
import { Question, QuestionType } from '@/models/configurator/question';

// mixins
import componentState from '@/mixins/state';
import { get } from 'vuex-pathify';
import { Answer } from '@/models/configurator/answer';
import { mapActions } from 'vuex';

const baseMixins = mixins(componentState);

export default baseMixins.extend({
  name: 'ProductQuestionnaireCard',
  props: {
    module: {
      type: Object as PropType<Module>,
      required: true
    },

    configuration: {
      type: Object as PropType<Configuration>,
      required: true
    },

    snapshot: {
      type: Number as PropType<number>
    }
  },

  data: () => ({
    currentQuestionIndex: 1,
    currentAnswer: null as null | number,
    allQuestionsAnswered: false
  }),

  computed: {
    answers: get<Answer[]>('configuratorAnswer/answers'),

    questions: get<Question[]>('configuratorQuestion/questions'),

    configurationId(): number | undefined {
      return this.configuration.id;
    },
    hasNextQuestion(): boolean {
      return this.currentQuestionIndex < this.questions.length - 1;
    },

    hasPrevQuestion(): boolean {
      return this.currentQuestionIndex > 0;
    },

    firstQuestionId(): number | undefined {
      return this.questions[0].id;
    }
  },

  // to fix the issue of componenet starting at initial state of Loaded the being set twice
  // calling mounted twice
  beforeMount() {
    this.setComponentState('loading');
  },

  async mounted() {
    // await answers list first
    await this.fetchAnswers(this.configurationId);
    // fetch first question to get the appropiate configuration question
    await this.fetchQuestion({
      module: this.module.id,
      id: this.getCurrentQuestionId(),
      configuration: this.configurationId
    })
      .then(() => {
        this.updateAnswer(this.firstQuestionId!);
      })
      .finally(() => {
        this.setComponentState('loaded');
      });
  },

  methods: {
    ...mapActions('snackbar', ['createSnack']),
    ...mapActions('configuratorAnswer', ['fetchAnswers', 'deleteAnswer']),
    ...mapActions('configuratorQuestion', ['fetchQuestion']),

    save() {
      this.$emit('save', this.allQuestionsAnswered);
    },

    getPrevQuestionId(index: number) {
      const prevIndex =
        (index + this.questions.length - 1) % this.questions.length;
      const item = this.questions[prevIndex];
      return item.id;
    },

    getNextQuestionId(index: number) {
      const nextIndex = (index + 1) % this.questions.length;
      const item = this.questions[nextIndex];
      return item.id;
    },

    getCurrentQuestionId() {
      const nextIndex = this.currentQuestionIndex;
      const item = this.questions[nextIndex - 1]; //LF-2021-05-19 -- Hack, we need to default currentQuestionIndex to zero instead of one
      return item.id;
    },

    updateAnswer(questionId?: number) {
      if (!questionId) return;

      // stop if no answers exist
      if (!this.answers.length) return;

      // since the answer be set multiple times;
      // look into filter the sets into an array and use the last answer that matches
      const newAnswer = this.answers
        .filter(ans => ans.question == questionId)
        .pop();

      const answer = newAnswer?.choice ?? newAnswer?.value ?? null;

      // Only update answer if not null - avoids form validation error
      this.currentAnswer = answer;
    },

    async skipQuestion(index: number) {
      await this.createSnack({
        color: 'success',
        type: 'success',
        right: true,
        useBtn: false,
        msg: 'Skipped question due to only one choice avaliable',
        btnText: 'Close',
        timeout: 6000,
        action: function() {}
      }).then(() => this.fetchNextQuestion(index));
    },

    fetchNextQuestion(index: number) {
      this.fetchQuestion({
        module: this.module.id,
        id: this.getNextQuestionId(index),
        configuration: this.configurationId
      })
        .then(async (question: Question) => {
          this.updateAnswer(this.getNextQuestionId(index));

          // set next question
          this.currentQuestionIndex = index + 2;

          // check if question is a choice and check length zero -
          // if so then show snackbar and skip
          if (
            (question.type == QuestionType.MultipleChoice ||
              question.type == QuestionType.NumericChoice) &&
            !question.choices
          ) {
            if (this.currentAnswer) {
              const answer = this.answers
                .filter(ans => ans.question == question.id)
                .pop();

              //TODO: LF-2021-03-16 - Need to handle error
              await this.deleteAnswer({
                configurationId: this.configurationId,
                id: answer?.id
              });
            }

            this.createSnack({
              color: 'warning',
              type: 'warning',
              right: true,
              useBtn: false,
              msg: 'Skipped question due to no choices avaliable',
              btnText: 'Close',
              timeout: 6000,
              action: function() {}
            }).then(() => {
              this.fetchNextQuestion(index + 1);
            });
          }
        })
        .catch(e => {
          this.createSnack({
            color: 'error',
            type: 'error',
            right: true,
            useBtn: false,
            msg: 'Error getting question, check the configuration',
            btnText: 'Skip',
            timeout: 6000,
            action: this.fetchNextQuestion(index + 1)
          }).then(() => {
            console.warn(e);
          });
        })
        .finally(() => {
          if (!this.hasNextQuestion) {
            this.allQuestionsAnswered = true;
          }
          this.$emit('submit');
        });
    },

    fetchPrevQuestion(index: number) {
      if (!this.hasPrevQuestion) return;

      const prevIndex =
        (index + this.questions.length - 1) % this.questions.length;

      this.fetchQuestion({
        module: this.module.id,
        id: this.getPrevQuestionId(index),
        configuration: this.configurationId
      })
        .then((question: Question) => {
          this.updateAnswer(this.getPrevQuestionId(index)!);

          // set next current question ot use in form
          this.currentQuestionIndex = prevIndex + 1;

          // check if question is multiple choice and check length if so then show snackbar and skip
          if (
            (question.type == QuestionType.MultipleChoice ||
              question.type == QuestionType.NumericChoice) &&
            !question.choices
          ) {
            this.createSnack({
              color: 'warning',
              type: 'warning',
              right: true,
              useBtn: false,
              msg: 'Skipped question due to no choices avaliable',
              btnText: 'Close',
              timeout: 6000,
              action: function() {}
            }).then(() => {
              this.fetchPrevQuestion(prevIndex);
            });
          }
        })
        .catch(e => {
          this.createSnack({
            color: 'error',
            type: 'error',
            right: true,
            useBtn: false,
            msg: 'Error getting question, check the configuration',
            btnText: 'Skip',
            timeout: 6000,
            action: () => {}
          }).then(() => {
            console.warn(e);
          });
        });
    }
  }
});
